/**
 * AndroidOpdateringsBanner
 *
 * Viser et diskret banner i bunden af skærmen når der er en ny APK tilgængelig.
 * Aktiveres KUN i Capacitor-appen (window.Capacitor truthy) — er fuldstændig
 * usynlig i browser og staging.
 *
 * Design:
 *   - Samme visuelle stil som det eksisterende nyVersionBanner (blå gradient)
 *   - "Opdater nu" → downloader og starter install-flow
 *   - "Senere" → skjuler for resten af sessionen
 *   - Vises IKKE oven på det eksisterende nyVersionBanner (web-reload-banner)
 *
 * Placering i DOM: fast bund, z-index 9991 (under import-statusbar 10001,
 * over MobilBottomNav 9980)
 */

import React from 'react';
import { useAndroidOpdatering } from '../hooks/useAndroidOpdatering';

export default function AndroidOpdateringsBanner() {
  const { opdatering, installerer, installerOpdatering, afvisOpdatering, erCapacitorApp } =
    useAndroidOpdatering();

  // Ingenting at vise
  if (!erCapacitorApp || !opdatering) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9991,
        background: 'linear-gradient(90deg, #14166e 0%, #2322be 60%, #4140d4 100%)',
        color: '#fff',
        padding: '12px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        fontSize: 14,
        boxShadow: '0 -4px 24px rgba(20,22,110,0.6)',
        borderTop: '1px solid rgba(255,255,255,0.12)',
      }}
    >
      {/* Tekst + versioninfo */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, fontSize: 13, letterSpacing: 0.2 }}>
          App-opdatering tilgængelig
        </div>
        <div style={{ fontSize: 12, opacity: 0.82, marginTop: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          Version {opdatering.version}
          {opdatering.noter ? ` — ${opdatering.noter}` : ''}
        </div>
      </div>

      {/* Handlingsknapper */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexShrink: 0 }}>
        <button
          onClick={installerOpdatering}
          disabled={installerer}
          style={{
            background: '#fff',
            color: '#14166e',
            border: 'none',
            borderRadius: 7,
            padding: '7px 16px',
            fontWeight: 700,
            cursor: installerer ? 'wait' : 'pointer',
            fontSize: 13,
            opacity: installerer ? 0.7 : 1,
            transition: 'opacity 0.2s',
            whiteSpace: 'nowrap',
          }}
        >
          {installerer ? 'Starter...' : 'Opdater nu'}
        </button>

        <button
          onClick={afvisOpdatering}
          aria-label="Luk opdateringsbesked"
          style={{
            background: 'none',
            border: 'none',
            color: 'rgba(255,255,255,0.65)',
            cursor: 'pointer',
            fontSize: 22,
            lineHeight: 1,
            padding: '0 4px',
            fontWeight: 300,
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
